<template>
  <div class="bg">
    <div class="content">
      <div class="btn">
        <el-button type="info" @click="quitBtn" size="mini"> 取消 </el-button>
        <el-button type="primary" size="mini" @click="submitForm('infoForm')">
          提交
        </el-button>
      </div>
      <el-form
        ref="infoForm"
        :rules="rules"
        :model="infoForm"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-form-item label="企业名称：" prop="name">
            <el-input v-model="infoForm.name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="信用代码：" prop="code">
            <el-input v-model="infoForm.code" placeholder="请输入企业信用代码"></el-input>
          </el-form-item>
          <el-form-item label="企业类型：" prop="type">
            <span @click="typeOption">{{ typeName }}</span>
            <van-popup
              v-model="showTypePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择企业类型"
                show-toolbar
                :columns="typeOptions"
                @confirm="onConfirmType"
                @cancel="showTypePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="企业地址：" prop="enterpriseAddress">
            <el-input
              v-model="infoForm.enterpriseAddress"
              placeholder="请输入企业地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人姓名：" prop="legalPerson">
            <el-input
              v-model="infoForm.legalPerson"
              placeholder="请输入法人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="legalPhone">
            <el-input
              v-model="infoForm.legalPhone"
              placeholder="请输入法人联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注信息：">
            <el-input
              v-model="infoForm.remark"
              placeholder="请输入备注信息"
              size="mini"
              clearable
              type="textarea"
            />
          </el-form-item>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import formRules from "@/utils/formRules.js";
import { filtration$ } from "@/utils/admin";
import { postDictCode } from "@/api/dict";
// import { getProjectList, postProjectId } from "@/api/app/project";
import { postSubmitForm, postDetail } from "@/api/app/enterprise";
export default {
  data() {
    return {
      // 项目选择器
      projectOptions: [],
      showProjectPopup: false,
      // 企业选择器
      typeOptions: [],
      showTypePopup: false,
      typeName: "请选择所属企业",
      infoForm: {},
      // infoIdForm: {},
      // 表单验证
      rules: {
        name: [{ required: true, message: "企业名称不能为空" }],
        code: [
          { required: true, message: "信用代码不能为空" },
          { validator: formRules.validateCorpCode, trigger: "blur" },
        ],
        type: [{ required: true, message: "企业类型不能为空" }],
        enterpriseAddress: [{ required: true, message: "企业名称不能为空" }],
        legalPerson: [
          { required: true, message: "法人姓名不能为空" },
          { validator: formRules.validateCn, trigger: "blur" },
        ],
        legalPhone: [
          { required: true, message: "联系电话不能为空" },
          { validator: formRules.validatePhone, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    if (this.$route.params.addOrEdit == "1") {
      this.unitDetail();
    }
  },
  methods: {
    // 获取企业类型
    typeOption() {
      this.showTypePopup = true;
      postDictCode("enterprise_type").then((res) => {
        this.typeOptions =res.data.map((item) => {
          return { text: item.label, ...item };
        });
      });
    },
    // 选择企业类型
    onConfirmType(type) {
      this.typeName = type.text;
      this.infoForm["type"] = type.value;
      this.showTypePopup = false;
    },
    // 提交信息
    submitForm(infoForm) {
      this.$refs["infoForm"].validate((valid) => {
        if (valid) {
          postSubmitForm(filtration$(this.infoForm))
            .then((res) => {
              if (this.$route.params.addOrEdit == "0" && res.code == 200) {
                this.$notify({ type: "success", message: "添加成功！" });
                this.$refs["infoForm"].resetFields();
                  this.$router.back();
              } else if (this.$route.params.addOrEdit == "1" && res.code == 200) {
                this.$notify({ type: "success", message: "修改成功！" });
                  this.$router.back();
              }
            })
            .catch((error) => {
              this.$store.dispatch("submitToken");
            });
        }
      });
    },
    // 通过列表id获取详细信息
    unitDetail() {
      postDetail(this.$store.state.app.itemId).then((res) => {
        this.infoForm = res.data;
        this.$store.state.app.dict.find((item) => {
          if (res.data.type == item.value) {
            this.typeName = item.label;
            this.infoForm.type = item.value;
          }
        });
      });
    },
    //取消按钮
    quitBtn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  min-height: 100vh;
  background-color: #f0f0f0;
}

.content {
  padding: 10px;
  .btn {
    text-align: right;
    margin-bottom: 10px;
  }
  /deep/.el-card {
    margin-bottom: 10px;
    .el-form-item {
      margin-bottom: 0px;
      // span:nth-child(1) {
      //   color: #c0c4cc;
      // }
    }
    .el-form-item__label {
      padding: 0;
    }
    .el-input__inner {
      border: unset;
      padding: 0;
    }
  }
}
</style>
